/************************************************************************
 ** IBM Confidential
 **
 ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
 **
 ** (C) Copyright IBM Corp. 2024
 **
 ** The source code for this program is not published or otherwise divested of its trade secrets, 
 ** irrespective of what has been deposited with the U.S. Copyright Office.
 ************************************************************************/
// GENERATED
import MoserObject from './MoserObject';
//@import com/ibm/bi/platform/moser/common/generated/metadata/MoserObject (loadtime) // superclass, fromJSONHelper

/**
 * <p>Java class for anonymous complex type. <p>The following schema fragment specifies the expected content contained within this class. <pre> &lt;complexType&gt; &lt;complexContent&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}anyType"&gt; &lt;sequence&gt; &lt;element name="location" type="{http://www.w3.org/2001/XMLSchema}string"/&gt; &lt;element name="errorCode" type="{http://www.w3.org/2001/XMLSchema}string"/&gt; &lt;element name="msg" type="{http://www.w3.org/2001/XMLSchema}string"/&gt; &lt;element name="severity" type="{http://www.w3.org/2001/XMLSchema}string"/&gt; &lt;element name="ruleId" type="{http://www.w3.org/2001/XMLSchema}string"/&gt; &lt;element name="detailMsg" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="errorData" minOccurs="0"&gt; &lt;complexType&gt; &lt;complexContent&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}anyType"&gt; &lt;sequence&gt; &lt;element name="line" type="{http://www.w3.org/2001/XMLSchema}string"/&gt; &lt;element name="character" type="{http://www.w3.org/2001/XMLSchema}string"/&gt; &lt;/sequence&gt; &lt;/restriction&gt; &lt;/complexContent&gt; &lt;/complexType&gt; &lt;/element&gt; &lt;element name="type" type="{http://www.w3.org/2001/XMLSchema}string"/&gt; &lt;/sequence&gt; &lt;/restriction&gt; &lt;/complexContent&gt; &lt;/complexType&gt; </pre>
 */
export default class ValidationMessage extends MoserObject{

	location = null;

	errorCode = null;

	msg = null;

	severity = null;

	ruleId = null;

	detailMsg = null;

	errorData = null;

	type = null;



	/**
	 * Gets the value of the location property.
	 * @return {String} possible object is {@link String}
	 */
	getLocation() {
		return this.location;
	}

	/**
	 * Sets the value of the location property.
	 * @param {String} value allowed object is {@link String}
	 */
	setLocation(value) {
		var oldValue = this.location;
		this.location = value;
		this._setAndNotify(76, oldValue, value, false, false);
	}

	/**
	 * Gets the value of the errorCode property.
	 * @return {String} possible object is {@link String}
	 */
	getErrorCode() {
		return this.errorCode;
	}

	/**
	 * Sets the value of the errorCode property.
	 * @param {String} value allowed object is {@link String}
	 */
	setErrorCode(value) {
		var oldValue = this.errorCode;
		this.errorCode = value;
		this._setAndNotify(77, oldValue, value, false, false);
	}

	/**
	 * Gets the value of the msg property.
	 * @return {String} possible object is {@link String}
	 */
	getMsg() {
		return this.msg;
	}

	/**
	 * Sets the value of the msg property.
	 * @param {String} value allowed object is {@link String}
	 */
	setMsg(value) {
		var oldValue = this.msg;
		this.msg = value;
		this._setAndNotify(78, oldValue, value, false, false);
	}

	/**
	 * Gets the value of the severity property.
	 * @return {String} possible object is {@link String}
	 */
	getSeverity() {
		return this.severity;
	}

	/**
	 * Sets the value of the severity property.
	 * @param {String} value allowed object is {@link String}
	 */
	setSeverity(value) {
		var oldValue = this.severity;
		this.severity = value;
		this._setAndNotify(79, oldValue, value, false, false);
	}

	/**
	 * Gets the value of the ruleId property.
	 * @return {String} possible object is {@link String}
	 */
	getRuleId() {
		return this.ruleId;
	}

	/**
	 * Sets the value of the ruleId property.
	 * @param {String} value allowed object is {@link String}
	 */
	setRuleId(value) {
		var oldValue = this.ruleId;
		this.ruleId = value;
		this._setAndNotify(80, oldValue, value, false, false);
	}

	/**
	 * Gets the value of the detailMsg property.
	 * @return {String} possible object is {@link String}
	 */
	getDetailMsg() {
		return this.detailMsg;
	}

	/**
	 * Sets the value of the detailMsg property.
	 * @param {String} value allowed object is {@link String}
	 */
	setDetailMsg(value) {
		var oldValue = this.detailMsg;
		this.detailMsg = value;
		this._setAndNotify(81, oldValue, value, false, false);
	}

	/**
	 * Gets the value of the errorData property.
	 * @return {ErrorData} possible object is {@link ValidationMessage.ErrorData}
	 */
	getErrorData() {
		return this.errorData;
	}

	/**
	 * Sets the value of the errorData property.
	 * @param {ErrorData} value allowed object is {@link ValidationMessage.ErrorData}
	 */
	setErrorData(value) {
		var oldValue = this.errorData;
		this.errorData = value;
		this._setAndNotify(82, oldValue, value, true, false);
	}

	/**
	 * Gets the value of the type property.
	 * @return {String} possible object is {@link String}
	 */
	getType() {
		return this.type;
	}

	/**
	 * Sets the value of the type property.
	 * @param {String} value allowed object is {@link String}
	 */
	setType(value) {
		var oldValue = this.type;
		this.type = value;
		this._setAndNotify(83, oldValue, value, false, false);
	}

	/**
	 * Creates a new instance of <code>ValidationMessage</code> object from JSON data.
	 * @param {ObjectFactory} factory <code>ObjectFactory</> object for object creation.
	 * @param {Object} json JSON data to be used to create the <code> ValidationMessage</code> object from.
	 * @return {ValidationMessage} an object of type <code>ValidationMessage</code>
	 */
	static fromJSON(json, factory) {
		var result = factory.createValidationMessage();
		var featureList = result.getFeatureList(factory);
		MoserObject.fromJSONHelper(result, featureList, json, factory);
		return result;
	}

	/**
	 * Retrieves the type of this object
	 * @return {String} the object type in a <code>String</code>
	 */
	getObjectType() {
		return "ValidationMessage";
	}

	/**
	 * Get a list of FeatureObjects
	 * @return {Array} A list of FeatureObjects
	 */
	getFeatureList(factory) {
		var featureList = [];
		featureList.push(this.createFeature(false, false, false, 76, "location", null));
		featureList.push(this.createFeature(false, false, false, 77, "errorCode", null));
		featureList.push(this.createFeature(false, false, false, 78, "msg", null));
		featureList.push(this.createFeature(false, false, false, 79, "severity", null));
		featureList.push(this.createFeature(false, false, false, 80, "ruleId", null));
		featureList.push(this.createFeature(false, false, false, 81, "detailMsg", null));
		var clazz;
		if (factory) {
			clazz = factory.createValidationMessageErrorData().getClass();
		}
		featureList.push(this.createFeature(false, false, true, 82, "errorData", clazz));
		featureList.push(this.createFeature(false, false, false, 83, "type", null));
		Array.prototype.push.apply(featureList, super.getFeatureList(factory));
		return featureList;
	}

	/**
	 * Set the value of a specific feature.
	 * @param {BaseMoserObject} value the value to set
	 * @param {int} featureID the feature id of the attribute to be set
	 */
	set(featureID, value) {
		switch (featureID) {
		case 76:
			this.setLocation((value));
			break;
		case 77:
			this.setErrorCode((value));
			break;
		case 78:
			this.setMsg((value));
			break;
		case 79:
			this.setSeverity((value));
			break;
		case 80:
			this.setRuleId((value));
			break;
		case 81:
			this.setDetailMsg((value));
			break;
		case 82:
			this.setErrorData((value));
			break;
		case 83:
			this.setType((value));
			break;
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Get the value of a specific feature.
	 * @param {int} featureID the feature id of the attribute to get
	 */
	get(featureID) {
		switch (featureID) {
		case 76:
			return this.getLocation();
		case 77:
			return this.getErrorCode();
		case 78:
			return this.getMsg();
		case 79:
			return this.getSeverity();
		case 80:
			return this.getRuleId();
		case 81:
			return this.getDetailMsg();
		case 82:
			return this.getErrorData();
		case 83:
			return this.getType();
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Get the value of a specific feature.
	 * @param {int} featureID the feature id of the attribute to get
	 */
	basicGet(featureID) {
		switch (featureID) {
		case 76:
			return this.getLocation();
		case 77:
			return this.getErrorCode();
		case 78:
			return this.getMsg();
		case 79:
			return this.getSeverity();
		case 80:
			return this.getRuleId();
		case 81:
			return this.getDetailMsg();
		case 82:
			return this.getErrorData();
		case 83:
			return this.getType();
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}
}
/**
 * <p>Java class for anonymous complex type. <p>The following schema fragment specifies the expected content contained within this class. <pre> &lt;complexType&gt; &lt;complexContent&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}anyType"&gt; &lt;sequence&gt; &lt;element name="line" type="{http://www.w3.org/2001/XMLSchema}string"/&gt; &lt;element name="character" type="{http://www.w3.org/2001/XMLSchema}string"/&gt; &lt;/sequence&gt; &lt;/restriction&gt; &lt;/complexContent&gt; &lt;/complexType&gt; </pre>
 */
ValidationMessage.ErrorData = class extends MoserObject{

	line = null;

	character = null;



	/**
	 * Gets the value of the line property.
	 * @return {String} possible object is {@link String}
	 */
	getLine() {
		return this.line;
	}

	/**
	 * Sets the value of the line property.
	 * @param {String} value allowed object is {@link String}
	 */
	setLine(value) {
		var oldValue = this.line;
		this.line = value;
		this._setAndNotify(272, oldValue, value, false, false);
	}

	/**
	 * Gets the value of the character property.
	 * @return {String} possible object is {@link String}
	 */
	getCharacter() {
		return this.character;
	}

	/**
	 * Sets the value of the character property.
	 * @param {String} value allowed object is {@link String}
	 */
	setCharacter(value) {
		var oldValue = this.character;
		this.character = value;
		this._setAndNotify(273, oldValue, value, false, false);
	}

	/**
	 * Creates a new instance of <code>ErrorData</code> object from JSON data.
	 * @param {ObjectFactory} factory <code>ObjectFactory</> object for object creation.
	 * @param {Object} json JSON data to be used to create the <code> ErrorData</code> object from.
	 * @return {ErrorData} an object of type <code>ErrorData</code>
	 */
	static fromJSON(json, factory) {
		var result = factory.createValidationMessageErrorData();
		var featureList = result.getFeatureList(factory);
		MoserObject.fromJSONHelper(result, featureList, json, factory);
		return result;
	}

	/**
	 * Retrieves the type of this object
	 * @return {String} the object type in a <code>String</code>
	 */
	getObjectType() {
		return "ErrorData";
	}

	/**
	 * Get a list of FeatureObjects
	 * @return {Array} A list of FeatureObjects
	 */
	getFeatureList(factory) {
		var featureList = [];
		featureList.push(this.createFeature(false, false, false, 272, "line", null));
		featureList.push(this.createFeature(false, false, false, 273, "character", null));
		Array.prototype.push.apply(featureList, super.getFeatureList(factory));
		return featureList;
	}

	/**
	 * Set the value of a specific feature.
	 * @param {BaseMoserObject} value the value to set
	 * @param {int} featureID the feature id of the attribute to be set
	 */
	set(featureID, value) {
		switch (featureID) {
		case 272:
			this.setLine((value));
			break;
		case 273:
			this.setCharacter((value));
			break;
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Get the value of a specific feature.
	 * @param {int} featureID the feature id of the attribute to get
	 */
	get(featureID) {
		switch (featureID) {
		case 272:
			return this.getLine();
		case 273:
			return this.getCharacter();
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}

	/**
	 * Get the value of a specific feature.
	 * @param {int} featureID the feature id of the attribute to get
	 */
	basicGet(featureID) {
		switch (featureID) {
		case 272:
			return this.getLine();
		case 273:
			return this.getCharacter();
		default:
			throw new Error((("The feature " + featureID) + " is not valid."));
		}
	}
}


// WEBPACK FOOTER //
// ./src/generated/ValidationMessage.js